<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.22974 5.38501C4.86335 5.38501 3.54909 5.90941 2.558 6.85004C2.06584 7.3174 1.67372 7.88025 1.40592 8.50389C1.1381 9.12755 1 9.79916 1 10.4779C1 11.1566 1.1381 11.8282 1.40592 12.4519C1.67288 13.0735 2.06315 13.6346 2.55312 14.1011L11.4026 22.7024C11.8108 23.0991 12.4605 23.0991 12.8686 22.7024L21.7182 14.1011C22.2081 13.6346 22.5985 13.0735 22.8654 12.4519C23.1331 11.8282 23.2713 11.1566 23.2713 10.4779C23.2713 9.79916 23.1331 9.12755 22.8654 8.50389C22.5976 7.88025 22.2056 7.31761 21.7134 6.85025C20.7223 5.90962 19.4079 5.38501 18.0415 5.38501C16.6751 5.38501 15.3608 5.90941 14.3698 6.85004L14.3501 6.8692L12.1356 9.08369L9.92116 6.8692L9.90149 6.85004C8.91041 5.90941 7.59614 5.38501 6.22974 5.38501Z"
      :fill="`url(#${componentId}_paint0_linear_4224_1677)`"
    />
    <foreignObject
      x="5.2666"
      y="-1"
      width="13.7393"
      height="13.739"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(1px); clip-path: url(#${componentId}_bgblur_0_4224_1677_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <g :filter="`url(#${componentId}_filter0_i_4224_1677)`" data-figma-bg-blur-radius="2">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.1361 1C9.44674 1 7.2666 3.18016 7.2666 5.86952C7.2666 8.55888 9.44674 10.739 12.1361 10.739C14.8255 10.739 17.0056 8.55888 17.0056 5.86952C17.0056 3.18016 14.8255 1 12.1361 1Z"
        fill="#EC0F53"
        fill-opacity="0.48"
      />
    </g>
    <defs>
      <filter
        :id="`${componentId}_filter0_i_4224_1677`"
        x="5.2666"
        y="-1"
        width="13.7393"
        height="13.739"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dx="0.047683" dy="0.0238415" />
        <feGaussianBlur stdDeviation="0.119208" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0" />
        <feBlend mode="normal" in2="shape" result="effect1_innerShadow_4224_1677" />
      </filter>
      <clipPath :id="`${componentId}_bgblur_0_4224_1677_clip_path`" transform="translate(-5.2666 1)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.1361 1C9.44674 1 7.2666 3.18016 7.2666 5.86952C7.2666 8.55888 9.44674 10.739 12.1361 10.739C14.8255 10.739 17.0056 8.55888 17.0056 5.86952C17.0056 3.18016 14.8255 1 12.1361 1Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_4224_1677`"
        x1="19.9306"
        y1="3.78366"
        x2="0.0195105"
        y2="17.3582"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC3BB2" />
        <stop offset="1" stop-color="#F7906E" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
